import React from 'react';
import { History } from 'history';
import { Row, Col, Box, Botao, CampoTexto, Form, Alerta, TipoBotao, TipoAlerta, CampoEstatico, TipoCampoEstatico, PosicaoTituloCampoEstatico, CampoValor } from '@intechprev/componentes-web';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import moment from "moment";

import { Page } from "../";
import { FichaFechamentoService, PlanoService, FichaFinanceiraService, FuncionarioService } from "./../../services";
import { timingSafeEqual } from 'crypto';
import { NumFuncionalidade } from '../Page';

function formatValue(val: string) {
  const possibleNumber = Number(val);
  if (isNaN(possibleNumber))
    return Number(
      val.replace("R$", "")
        .replace(/\./g, "")
        .replace(",", ".")
    );
  return possibleNumber;
}

const SliderWithTooltip = createSliderWithTooltip(Slider);

interface Props {
  history?: History;
}

interface State {
  dataNascimento: string;
  saldoAcumulado: number;
  salarioContribuicao: number;
  dataUltimoSalario: string;
  percentualContrib: number;
  contribMensal: number;
  contribPatronal: number;
  idadeMinima: number;
  idadeMaxima: number;
  idadeAposentadoria: number;
  idadeAtual: number;
  percentualAVista: number;
  aporte: number;
  outroValor: number;
  naoParticipante: boolean;
  termoAceito: boolean;
  Erro: string;
}

export default class SimuladorBeneficios extends React.Component<Props, State> {

  private page = React.createRef<Page>();
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  state: State = {
    dataNascimento: "",
    saldoAcumulado: 0,
    salarioContribuicao: 0,
    dataUltimoSalario: "00/0000",
    percentualContrib: 0,
    contribMensal: 0,
    contribPatronal: 0,
    idadeMinima: 58,
    idadeMaxima: 80,
    idadeAposentadoria: 0,
    idadeAtual: 0,
    percentualAVista: 0,
    aporte: 0,
    outroValor: 0,
    naoParticipante: true,
    termoAceito: false,
    Erro: ""
  }

  componentDidMount = async () => {
    var planos = await PlanoService.Buscar();

    var saldos;
    var ultimaContribuicao;
    var idadePlano = 0;
    var naoParticipante = true;
    var plano;

    var planoFiltrado = planos.filter((plano: any) => plano.CD_PLANO !== "0001");

    if (planoFiltrado.length > 0) {
      plano = planoFiltrado[0];

      var cdPlano = plano.CD_PLANO;
      saldos = await FichaFechamentoService.BuscarSaldoPorPlano(cdPlano);
      ultimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano(cdPlano);

      var dataInscricao = moment(plano.DT_INSC_PLANO, "DD/MM/YYYY");
      idadePlano = moment().diff(dataInscricao, "years");

      naoParticipante = false;
    }

    var dataNascimento;

    if (naoParticipante) {
      const dados = await FuncionarioService.BuscarNP();
      dataNascimento = moment(dados.Funcionario.DT_NASCIMENTO, "DD/MM/YYYY");
    }
    else {
      const dados = await FuncionarioService.Buscar();
      dataNascimento = moment(dados.DadosPessoais.DT_NASCIMENTO, "DD/MM/YYYY");
    }

    var idadeAtual = moment().diff(dataNascimento, "years");

    var idadeMinima = this.state.idadeMinima;
    var idadeMaxima = this.state.idadeMaxima;

    // Idade Minima Nao Participante
    if (naoParticipante && idadeAtual > this.state.idadeMinima)
      idadeMinima = idadeAtual + 1;

    // Idade Minima Participante Normal
    if (!naoParticipante && idadeAtual > this.state.idadeMinima && idadePlano > 5)
      idadeMinima = idadeAtual;

    if (idadeAtual >= 80)
      idadeMaxima = 90;

    await this.setState({
      saldoAcumulado: saldos ? saldos.VL_ACUMULADO : 0,
      salarioContribuicao: ultimaContribuicao ? ultimaContribuicao.SRC : 0,
      dataUltimoSalario: ultimaContribuicao ? ultimaContribuicao.DataReferencia.substring(3) : "",
      percentualContrib: ultimaContribuicao ? ultimaContribuicao.Percentual : 2,
      idadeMinima,
      idadeMaxima,
      idadeAposentadoria: idadeMinima,
      idadeAtual,
      naoParticipante
    });

    await this.calcularPercentual(ultimaContribuicao ? ultimaContribuicao.Percentual : 2);
    await this.page.current.loading(false);
  }

  calcularPercentual = async (percentual: number) => {
    var percentualPatronal = percentual > 8 ? 8 : percentual;
    console.log({ salarioContribuicao: this.state.salarioContribuicao.toString() });
    var salarioContribuicao = formatValue(this.state.salarioContribuicao.toString());
    console.log({ salarioContribuicao });
    console.log({ percentual });
    await this.setState({
      percentualContrib: percentual,
      contribMensal: salarioContribuicao / 100 * percentual,
      contribPatronal: salarioContribuicao / 100 * percentualPatronal
    });
  }

  continuar = async () => {
    try {
      var alert = this.alert.current;
      var form = this.form.current;

      await alert.limparErros();
      await form.validar();

      if (form.isValido()) {
        if (this.state.naoParticipante) {
          const dta = moment(this.state.dataNascimento, "dd/MM/yyyy");

          if (!dta.isValid()) {
            alert.adicionarErro('Campo "Data de Nascimento" inválido.');
            return;
          }
        }

        var outroValor = formatValue(this.state.outroValor.toString());
        if (outroValor > 0) {
          await this.setState({
            aporte: outroValor
          });
        }

        if (this.state.percentualContrib >= 8)
          this.props.history.push({
            pathname: `/simulador/maior8`,
            state: {
              ...this.state,
              aporte: outroValor > 0 ? outroValor : this.state.aporte
            }
          });
        else
          this.props.history.push({
            pathname: `/simulador/menor8`,
            state: {
              ...this.state,
              aporte: outroValor > 0 ? outroValor : this.state.aporte
            }
          });
      }
    }
    catch (err) {
      if (err.response)
        this.alert.current.adicionarErro(err.response.data);
      else
        this.alert.current.adicionarErro(err);
    }
  }

  calcularIdadeNP = () => {
    var dataNascimento = moment(this.state.dataNascimento, "DD/MM/YYYY");

    var idadeAtual = moment().diff(dataNascimento, "years");

    var idadeMinima = this.state.idadeMinima;
    var idadeMaxima = this.state.idadeMaxima;

    // Idade Minima Nao Participante
    if (idadeAtual > this.state.idadeMinima)
      idadeMinima = idadeAtual + 1;

    if (idadeAtual >= 80)
      idadeMaxima = 90;

    this.setState({
      idadeMinima,
      idadeMaxima,
      idadeAposentadoria: idadeMinima,
      idadeAtual
    });
  };

  setAporte = (val: number) => {
    this.setState({
      aporte: val,
      outroValor: 0
    });
  };

  setOutroValor = (e: any) => {
    var outroValor = formatValue(this.state.outroValor.toString());
    if (outroValor > 0) {
      this.setState({
        aporte: 0
      });
    }
  }

  render() {
    if (this.state.Erro !== "") {
      return (
        <Page Funcionalidade={NumFuncionalidade.SIMULADOR_DE_BENEFÍCIOS_CODEPREV} {...this.props} ref={this.page}>

          <Alerta tipo={TipoAlerta.danger} mensagem={this.state.Erro} />

        </Page>
      );
    }
    return (
      <Page Funcionalidade={NumFuncionalidade.SIMULADOR_DE_BENEFÍCIOS_CODEPREV} {...this.props} ref={this.page}>
        <Box>
          <Form ref={this.form}>
            <h2>Bem-vindo ao simulador de benefícios do plano CODEPREV!</h2>
            <h3 className={"mb-5 mt-3"}>
              O seu benefício será simulado com base no seu Saldo de Conta Aplicável acumulado,
              até o momento, com o acréscimo das suas contribuições futuras até a data da sua aposentadoria.
              A taxa referencial de juros utilizada na simulação é de 3,5% ao ano.
            </h3>

            {/* Nao Participante */}
            {this.state.naoParticipante && <>
              <CampoValor
                contexto={this}
                nome={"salarioContribuicao"}
                valor={this.state.salarioContribuicao}
                titulo={"Seu Último Salário de Contribuição"}
                onChange={(e: any) => this.setState({ salarioContribuicao: e.target.value })}
                onBlur={() => this.calcularPercentual(this.state.percentualContrib)}
                tamanhoTitulo={"lg-3"}
                obrigatorio
              />

              <CampoTexto
                contexto={this}
                nome={"dataNascimento"}
                valor={this.state.dataNascimento}
                titulo={"Data de Nascimento"}
                tamanhoTitulo={"lg-3"}
                mascara={"99/99/9999"}
                onBlur={this.calcularIdadeNP}
                obrigatorio
              />
            </>}

            {/* Participante Normal */}
            {!this.state.naoParticipante && <>
              <h4 className={"mt-5 mb-2"}>Seu Saldo Acumulado Atualizado</h4>
              <h5 className={"text-secondary"}><CampoEstatico valor={this.state.saldoAcumulado} tipo={TipoCampoEstatico.dinheiro} /></h5>


              <h4 className={"mt-5 mb-2"}>Seu Último Salário de Contribuição (em {this.state.dataUltimoSalario})</h4>
              <h5 className={"text-secondary"}><CampoEstatico valor={this.state.salarioContribuicao} tipo={TipoCampoEstatico.dinheiro} /></h5>
            </>}

            <br />

            <h4 className={"mt-5 mb-2"}>Entre com o percentual de contribuição mensal desejado</h4>
            <div className={"mb-5 pl-4 pr-4"}>
              <SliderWithTooltip tipFormatter={(v: number) => `${v} %`}
                tipProps={{ placement: 'bottom', visible: true }}
                min={2} max={30} value={this.state.percentualContrib} dots={true}
                onChange={this.calcularPercentual} />
            </div>

            <CampoEstatico titulo={`Contribuição Mensal`} valor={this.state.contribMensal} tamanhoTitulo={"4"}
              tipo={TipoCampoEstatico.dinheiro} />

            <CampoEstatico titulo={`Contribuição Patronal (paritária até 8%)`} valor={this.state.contribPatronal} tamanhoTitulo={"4"}
              tipo={TipoCampoEstatico.dinheiro} />
            <br />

            <h4 className={"mt-5 mb-2"}>Com quantos anos você deseja se aposentar?</h4>
            <div className={"mb-5 pl-4 pr-4"}>
              <SliderWithTooltip tipFormatter={(v: number) => `${v} anos`}
                tipProps={{ placement: 'bottom', visible: true }}
                min={this.state.idadeMinima} max={this.state.idadeMaxima} value={this.state.idadeAposentadoria} dots={true}
                onChange={(val) => this.setState({ idadeAposentadoria: val })} />
            </div>
            <br />

            <h4 className={"mt-5 mb-2"}>Qual percentual do seu Saldo você deseja receber à vista na concessão do benefício?</h4>
            <div className={"mb-5 pl-4 pr-4"}>
              <SliderWithTooltip tipFormatter={(v: number) => `${v} %`}
                tipProps={{ placement: 'bottom', visible: true }}
                min={0} max={25} value={this.state.percentualAVista} dots={true}
                onChange={(val) => this.setState({ percentualAVista: val })} />
            </div>
            <br />

            <h4 className={"mt-5 mb-2"}>Deseja fazer um aporte de Contribuição Extraordinária?</h4>
            <div className={"mb-5 pl-4 pr-4"}>
              <SliderWithTooltip tipFormatter={(v: number) => <CampoEstatico valor={v} tipo={TipoCampoEstatico.dinheiro} />}
                tipProps={{ placement: 'bottom', visible: true }}
                min={0} max={50000} step={1000} value={this.state.aporte} dots={true}
                onChange={this.setAporte} />
            </div>

            <CampoValor
              contexto={this}
              nome={"outroValor"}
              valor={this.state.outroValor}
              titulo={"Outro Valor"}
              onBlur={this.setOutroValor}
            />
            <br />

            <div className={"alert alert-warning pt-4"}>
              <p>
                <ul>
                  <li>Esta é uma simulação de benefício considerando as informações do participante posicionada na data da realização do cálculo.</li>
                  <li>Os cálculos apresentados não são definitivos e resultam de projeções de caráter apenas ilustrativo, não gerando qualquer direito ao recebimento.</li>
                  <li>O presente cálculo poderá sofrer alterações quando da concessão definitiva do benefício.</li>
                  <li>Esta simulação observou as regras do Regulamento do Plano de Benefícios ao qual o participante está vinculado, vigentes na data da realização da presente simulação.</li>
                </ul>
              </p>

              <Row>
                <Col tamanho={"1"} className={"text-right"}>
                  <input type={"checkbox"} checked={this.state.termoAceito} onChange={() => this.setState({ termoAceito: !this.state.termoAceito })} />
                </Col>
                <Col>
                  <p>
                    Li e entendi!
                  </p>
                </Col>
              </Row>
            </div>

            <Alerta ref={this.alert} padraoFormulario tipo={TipoAlerta.danger} tamanho={"6"} />
            <br /><br />
            <Botao titulo={"Simular"} tipo={TipoBotao.primary} submit onClick={this.continuar} desativado={!this.state.termoAceito} />
          </Form>
        </Box>
      </Page>
    )
  }
}